import React from 'react'
import {Row,Col,Button,Breadcrumb,Icon} from 'antd'
import {Link} from 'react-router-dom'
import * as CmsUtil from './CmsUtil'
import * as CacheUtil from '../util/CacheUtil'

export default class Loading extends React.Component {
  state={}
  componentDidMount() {
    this.setup()
  }
  slug() {
    const {match} = this.props
    const {params} = match
    const {slug} = params
    if (typeof(slug)==='string'&&slug.length>0) {
      return slug
    }
    return ''
  }
  setup=()=>{
    const slug = this.slug()
    if (typeof(slug)==='string'&&slug.length>0) {
      const slugs = CacheUtil.get(CmsUtil.POST__SLUG)
      if (Array.isArray(slugs)&&slugs.length>0) {
        this.load(slugs)
      } else {
        CmsUtil.fetchSlugs(CmsUtil.POST,this.load,this.cbe)
      }
    }
  }
  cbe=e=>{
    if (e) {
      this.setState((prevState,props)=>{
        const {err} = prevState
        if (Array.isArray(err)) {
          err.push(e)
          return {err}
        }
        return {err:[e]}
      })
    }
  }
  load=slugs=>{
    if (Array.isArray(slugs)&&slugs.length>0) {
      const s = this.slug()
      const index = slugs.findIndex(e=>e._slug===s)
      if (index>=0) {
        const slug = slugs[index]
        const prev = slugs[index-1]
        const next = slugs[index+1]
        this.setState({slug,prev,next})
      }
    }
  }
  handleNav=()=>{
    const {onChange} = this.props
    if (typeof(onChange)==='function') {
      onChange()
    }
  }
  renderPrev() {
    const {prev} = this.state
    if (typeof(prev)==='object'&&prev!==null) {
      const {name,_slug} = prev
      const to = `/post/${_slug}`
      return (
        <Link to={to} onClick={this.handleNav}>
          <Button ghost size="small" className="mb-2"><Icon type="left" />{name}</Button>
        </Link>
      )
    }
    return null
  }
  renderNext() {
    const {next} = this.state
    if (typeof(next)==='object'&&next!==null) {
      const {name,_slug} = next
      const to = `/post/${_slug}`
      return (
        <Link to={to} className="float-right" onClick={this.handleNav}>
          <Button ghost size="small">{name}<Icon type="right" /></Button>
        </Link>
      )
    }
    return null
  }
  renderNavigator() {
    return (
      <Row className="content-navigator mb-3">
        <Col xs={24} sm={12} md={12} lg={12}>
          {this.renderPrev()}
        </Col>
        <Col xs={24} sm={12} md={12} lg={12}>
          {this.renderNext()}
        </Col>
      </Row>
    )
  }
  render() {
    const {slug} = this.state
    const name = typeof(slug)==='object'?slug.name:''
    return (
      <div className="cms-content">
        <Breadcrumb className="color-white text-shadow">
          <Breadcrumb.Item><Link to="/"><Icon type="home" className="mr-2" /> Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item>{name}</Breadcrumb.Item>
        </Breadcrumb>
        <h1 className="text-center content-title text-shadow">{name}</h1>
        {this.renderNavigator()}
        <div className="main-content mb-4">
          <Icon type="loading" />
        </div>
        {this.renderNavigator()}
      </div>
    )
  }
}
